import { Injectable } from '@angular/core';
import { constants } from 'src/environments/constants';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class FilterMappingService {

  constructor(private confSvc: ConfigService) { }

  getScreenSizeFilterRanges(screenSizeFilters: number[]): number[][] {
    const ranges = [];

    if (this.screenSizeFiltersIncludeRange(constants.TEN_ELEVEN_SCREEN_SIZE_RANGE, screenSizeFilters)) {
      ranges.push(constants.TEN_ELEVEN_SCREEN_SIZE_RANGE);
    }
    if (this.screenSizeFiltersIncludeRange(constants.TWELVE_THIRTEEN_SCREEN_SIZE_RANGE, screenSizeFilters)) {
      ranges.push(constants.TWELVE_THIRTEEN_SCREEN_SIZE_RANGE);
    }
    if (this.screenSizeFiltersIncludeRange(constants.FOURTEEN_FIFTEEN_SCREEN_SIZE_RANGE, screenSizeFilters)) {
      ranges.push(constants.FOURTEEN_FIFTEEN_SCREEN_SIZE_RANGE);
    }

    return ranges;
  }

  screenSizeFiltersIncludeRange(range: number[], filters: number[]): boolean {
    return range.some(x => filters.includes(x))
  }

  getScreenSizeFilterLabel(range: number[]): string {
    switch (range) {
      case constants.TEN_ELEVEN_SCREEN_SIZE_RANGE:
        return constants.TEN_ELEVEN_SCREEN_SIZE_LABEL;
      case constants.TWELVE_THIRTEEN_SCREEN_SIZE_RANGE:
        return constants.TWELVE_THIRTEEN_SCREEN_SIZE_LABEL;
      case constants.FOURTEEN_FIFTEEN_SCREEN_SIZE_RANGE:
        return constants.FOURTEEN_FIFTEEN_SCREEN_SIZE_LABEL;
      default:
        return '';
    }
  }

  getFeatureFilterLabel(keyword: string): string {
    switch (keyword) {
      case constants.TOUCHSCREEN:
        return this.confSvc.getString("touchscreenFilterLabel");
      default:
        return "";
    }
  }

  getOsTypeFilterLabel(keyword: string): string {
    switch (keyword) {
      case constants.ENTERPRISE:
        return this.confSvc.getString("enterpriseFilterLabel");
      case constants.NON_ENTERPRISE:
        return this.confSvc.getString("nonEnterpriseFilterLabel");
      default:
        return "";
    }
  }
}
